<template>
  <div data-component="alerts-manager">
    <notifications
      animation-type="css"
      :class="{
        'alert-card': true,
        'alert-card_mini': mini && isLogged,
        'alert-card_auth-page': !isLogged,
        'alert-card_help-widget': isHelpWidget,
      }"
      position="bottom left"
      :ignore-duplicates="true"
      :reverse="true"
      :speed=1
    >
      <template
        slot="body"
        slot-scope="props"
      >
        <div
          class="alert-card__wrap"
          :class='"alert-card__" + props.item.type'
        >
          <v-icon 
            color="white"
            class="material-icons-outlined"  
          >
            {{ getIcon(props.item.type) }}
          </v-icon>

          <div>
            {{ props.item.text }}
          </div>

          <v-btn
            text
            depressed
            fab
            icon
            small
            @click="$notify.close(props.item.id)"
          >
            <v-icon color="white" class="material-icons-outlined">
              close
            </v-icon>
          </v-btn>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
  import { isNonEmptyArr } from '../utils';

  export default {
    props: {
      mini: {
        type: Boolean,
        default: false,
      },
      isLogged: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dismissTimeout: import.meta.env.VUE_APP_ALERT_DURATION,
      };
    },
    computed: {
      allAlerts: {
        get() {
          return this.$store.getters['alerts/all'];
        },
        set(alert) {
          return this.$store.dispatch('alerts/set', alert);
        }
      },
      isHelpWidget() {
        return window.groove?.widget;
      },
    },
    watch: {
      allAlerts(nextVal) {
        if (!isNonEmptyArr(nextVal)) {
          return;
        }

        this.$notify({
          clean: true
        });

        setTimeout(() => {
          const alert = nextVal[nextVal.length - 1];

          const alertId = Date.now();

          const alertData = {
            id: alertId,
            duration: this.dismissTimeout,
            text: alert.message,
            type: alert.alertType,
          };

          this.showAlert(alertData);

          this.clearAlerts();
        }, 200);
      },
    },
    methods: {
      getIcon(type) {
        const icon = {
          error: 'error',
          success: 'check_circle',
          warning: 'warning',
        };

        return icon[type] || 'warning';
      },
      showAlert(alertData) {
        this.$notify(alertData);
      },
      clearAlerts() {
        return this.$store.dispatch('alerts/dismiss');
      },
    }
  };
</script>

<style lang="scss" scoped>
[data-component='alerts-manager'] {
  position: fixed;
  left: 0;
  bottom: 28px;
  width: 100%;
  z-index: 10000;

    .v-alert {
      border-radius: 0;
    }
  }

  .alert-card {
    --help-widget-width: 0px;
    --right-padding: 24px;
    --left-padding: 24px;
    --navigation-width: 220px;

    border-radius: 8px;
    bottom: 28px !important;
    color: #fff;
    font-size: 16px;
    left: calc(var(--left-padding) + var(--navigation-width)) !important;
    max-height: 100%;
    overflow: hidden;
    transition: all .3s;

    // change width based on different conditions
    width: calc(100% - var(--left-padding) - var(--navigation-width) - var(--help-widget-width) - var(--right-padding)) !important;

    &_help-widget {
      --right-padding: 40px;
      --help-widget-width: 170px;
    }
    
    &_mini {
      --navigation-width: 53px;
    }

    &_auth-page {
      --right-padding: 24px;
      --navigation-width: 0px;
      --help-widget-width: 0px;
    }

    &__error {
      background-color: #e53935;
    }

    &__warning {
      background-color: #fbc02d;
    }

    &__success {
      background-color: #43A047;
    }

    &__wrap {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 8px 16px;

      >.v-icon {
        margin: 0 16px 0 0;
      }

      >.v-btn {
        margin: 0 0 0 auto;
      }
    }
  }
</style>
